export default __webpack_public_path__ + "static/media/quirurgicos.35a9e634.jpg";